import React, { useState, useEffect } from "react";
import "../../styles/Styles.css";
import "../../styles/MenuItems.css";

function Soups() {

    const [soups, setSoups] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items') 
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'ZUPY');

            if (category) {
                setSoups(category.menu_items);
            };
        });
    }, []);

    return (
        <div className="container-fluid section-cream-background">
            <div className="container section-menu-item">
                <div className="menu-left-70">
                    <div className="menu-item-title-section d-flex justify-content-between align-items-end">
                    <p className="menu-item-title-font m-0 fs-1 fw-bold">ZUPY</p>
                    <p className="fs-5 mb-1 fw-light">300ml</p>
                    </div>
                    <hr/>
                    {soups.map((soup) => (
                        <div key={soup.id} className="container">
                            <div className="dish-name-container d-flex justify-content-between">
                                <p className="menu-item-title-font fs-5 m-0 ">{soup.name}</p>
                                <p className="fs-5 m-0">{soup.price}zł</p>
                            </div>
                            <p className="ingridients-container fs-6 fw-lighter m-0">{soup.ingredients}</p>
                            <div className="mb-3 mt-3 divide-line"/>
                        </div>
                    ))}
                </div>
                <div className="dish-photo-right-container-25">
                    <img src={require("../../assets/menu/soup.webp")} className="dish-photo-soups img-menu img-rounded shadow" />
                </div>
            </div>
        </div>
    )

}

export default Soups;